export const mockClientItems = (itemsNumber = 100) => {
  const mockItems = [];

  for (let i = 1; i < itemsNumber + 1; i += 1) {
    mockItems.push({
      key: `${i}`,
      DeviceName: `PPJ_STL_001_FP02`,
      DeviceType: "Node_STL",
      Latitude: 2.946174951,
      Longitude: 101.724579,
      FirmwareVersion: 1.02,
    });
  }
  return mockItems;
};

export const mockServerItems = async (serverOptions, data) => {
  const { page, rowsPerPage, sortBy, sortType } = serverOptions;
  const serverItemsLength = data.length;
  // const serverTotalItems = mockClientItems(serverItemsLength);
  const serverTotalItems = data

  if (sortBy && sortType) {
    serverTotalItems.sort((a, b) => {
      if (a[sortBy] < b[sortBy]) return sortType === "desc" ? 1 : -1;
      if (a[sortBy] > b[sortBy]) return sortType === "desc" ? -1 : 1;
      return 0;
    });
  }
  await new Promise((s) => setTimeout(s, 2000));
  return {
    serverCurrentPageItems: serverTotalItems.slice(
      (page - 1) * rowsPerPage,
      page * rowsPerPage
    ),
    serverTotalItemsLength: serverItemsLength,
  };
};
